<template>
  <div class="clm-wrapper">
    <the-auth-header />
    <the-auth-slider :main-slider-slides="pageData.mainSliderSlides"
                     :page-title="$i18n.locale=='ru' ? pageData.pageTitle : pageData.pageTitle_kz"
                     :page-subtitle-one="$i18n.locale=='ru' ? pageData.pageSubtitleOne : pageData.pageSubtitleOne_kz"
                     @popup:activate="onActivatePopup"
                     :page-params="pageParams"/>
    <the-auth-main :list-of-service="$i18n.locale=='ru' ? pageData.listOfService : pageData.listOfService_kz"
                   :page-subtitle-two="$i18n.locale=='ru' ? pageData.pageSubtitleTwo : pageData.pageSubtitleTwo_kz" :page-params="pageParams"/>
    <the-auth-footer
        :copyright="$i18n.locale=='ru' ? pageData.footer.copyright : pageData.footer_kz.copyright"
        :developer="$i18n.locale=='ru' ? pageData.footer.developer : pageData.footer_kz.developer"
        :links="$i18n.locale=='ru' ? pageData.footer.links : pageData.footer_kz.links"/>
    <transition name="v-fade">
      <div class="clm-popup" v-if="popupActive">
        <auth-form :id-prefix="'mob'" @close="popupActive = false" :start-tab="startTab" :page-params="pageParams"/>
      </div>
    </transition>
  </div>
</template>

<script>
import theAuthHeader from "../components/_the/the-auth-header";
import theAuthFooter from "../components/_the/the-auth-footer";
import theAuthMain from "../components/_the/the-auth-main/the-auth-main";
import theAuthSlider from "../components/_the/the-auth-slider/the-auth-slider";
import authForm from "../components/auth-form/auth-form";

export default {
  name: "layout-auth-page",
  components: {
    theAuthHeader,
    theAuthFooter,
    theAuthMain,
    theAuthSlider,
    authForm
  },
  props: {
    pageData: Object,
    pageParams: Object,
  },
  data() {
    return {
      popupActive: false,
      startTab: 'authFormAuth',
    }
  },
  provide() {
    return {
      locale: this.pageData.locale,
      needHelp: this.pageData.needHelp,
    }
  },
  methods: {
    onActivatePopup(tabName) {
      if (tabName) {
        this.startTab = tabName;
      }
      this.popupActive = true;
    }
  },
  created() {
    if (this.pageParams.startInNew) {
      // this.startTab = 'authFormNew'
      this.popupActive = true;
    }
  }
}
</script>
